<template>
  <div class="page-wrap">
    <!-- ========== 新增顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <!-- 移动端汉堡按钮 -->
        <div v-if="isMobile" class="hamburger-btn" @click="mobileMenuDrawer = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div class="header-right">
        <!-- 系统消息图标 -->
        <div class="header-icon">
          <i class="el-icon-bell"></i>
        </div>
        <!-- 账户下拉菜单 -->
      </div>
    </div>
    <TopSide @openSubMenu="openSubMenu2" />
    <!-- PC端：左侧导航 -->
    <div v-if="!isMobile" class="sidebar-wrap">
      <LeftSide :in-drawer="true" @openSubMenu="openSubMenu" />
    </div>

    <!-- 移动端左侧抽屉菜单 -->
    <el-drawer v-model="mobileMenuDrawer" direction="ltr" size="240px" :with-header="false">
      <LeftSide
        @openSubMenu="
          openSubMenu
          mobileMenuDrawer = false
        "
      />
    </el-drawer>

    <!-- 主体区域 -->
    <div class="main-content">
      <div class="page-top-title">
        <h1>我的任务</h1>
      </div>
      <div class="asset-content-row">
        <!-- 任务明细表格 -->
        <div class="asset-table-wrap">
          <div class="table-scroll-wrap">
            <el-table :data="damoxing_rec" height="650">
              <el-table-column label="内容" prop="content01" min-width="260" />
              <el-table-column label="积分" prop="jifen" width="100" />
              <el-table-column label="类型" prop="type" width="130">
                <template #default="scope">
                  <span v-if="scope.row.type === 1" type="primary">主查询</span>
                  <span v-else-if="scope.row.type === 2" type="success">电商主图设计</span>
                  <span v-else-if="scope.row.type === 3" type="info">A+详图</span>
                  <span v-else-if="scope.row.type === 4" type="warning">爆款图复刻</span>
                  <span v-else-if="scope.row.type === 5" type="danger">一键抠图</span>
                  <span v-else-if="scope.row.type === 6">商品装修</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="大模型名称" prop="damoxing_name" min-width="180" />
              <el-table-column label="创建时间" prop="add_time" min-width="200" />
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="table-pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="queryInfo.total" />
          </div>
        </div>
      </div>
    </div>

    <!-- ========== 右侧抽屉：电商图子菜单 ========== -->
    <el-drawer :visible.sync="subDrawerVisible" direction="rtl" size="260px" title="电商图设计" :before-close="closeSubDrawer">
      <div class="sub-menu-list">
        <div class="sub-menu-item" v-for="subItem in subMenuList" :key="subItem.path" @click="goPage(subItem.path)">
          <i :class="subItem.icon"></i>
          <span>{{ subItem.title }}</span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import LeftSide from '@/components/LeftSide.vue'
import TopSide from '@/components/TopSide.vue'
export default {
  components: { LeftSide, TopSide },
  data() {
    return {
      isMobile: false,
      mobileMenuDrawer: false,
      damoxing_rec: [],
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'task_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      subDrawerVisible: false,
      visible_loginMenu: false,
      subMenuList: [
        { title: '商品主图', icon: 'el-icon-picture', path: '/shop/main' },
        { title: '详情页设计', icon: 'el-icon-document', path: '/shop/detail' },
        { title: '场景效果图', icon: 'el-icon-s-platform', path: '/shop/scene' },
        { title: '批量修图', icon: 'el-icon-s-tools', path: '/shop/batch' }
      ]
    }
  },
  created() {
    const token = window.sessionStorage.getItem('token')
    this.visible_loginMenu = !!token
    this.getDamoxingRec()
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
  },
  methods: {
    openSubMenu2() {
      this.subDrawerVisible = true
    },
    checkDevice() {
      this.isMobile = window.innerWidth <= 768
    },
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.queryInfo.pageNum = 1
      this.getDamoxingRec()
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val
      this.getDamoxingRec()
    },
    handleAccountCommand(command) {
      switch (command) {
        case 'info':
          this.$router.push('/zichan')
          break
        case 'logout':
          this.$message.success('退出登录成功')
          window.sessionStorage.removeItem('token')
          this.$router.push('/mob')
          break
      }
    },
    login() {
      this.$router.push('/mob')
    },
    openSubMenu() {
      this.subDrawerVisible = true
    },
    closeSubDrawer(done) {
      done()
    },
    goPage(routePath) {
      this.$router.push(routePath)
      this.subDrawerVisible = false
    },
    async getDamoxingRec() {
      try {
        const { data: res } = await this.$http.get('get_api', { params: this.queryInfo })
        const resData = JSON.parse(res.data)
        if (!resData || resData.length === 0) {
          this.damoxing_rec = []
          this.queryInfo.total = 0
          return
        }
        this.damoxing_rec = resData[0].dataList || []
        this.queryInfo.total = resData[0].total
      } catch (err) {
        console.error('任务接口请求失败', err)
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
  background: #fff;
  border-bottom: 1px solid #e8edf2;
}
.header-left {
  display: flex;
  align-items: center;
}
.hamburger-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  border: 1px solid #e8edf2;
  color: #666;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  border: 1px solid #e8edf2;
}
.header-icon:hover {
  color: #22b8e6;
  border-color: #ccebfa;
}

/* 页面布局 */
.page-wrap {
  background-color: #fbfcfd;
  min-height: 100vh;
  padding-top: 56px;
  display: flex;
}
.sidebar-wrap {
  width: 120px;
  flex-shrink: 0;
}
.main-content {
  flex: 1;
  padding: 30px 24px;
  box-sizing: border-box;
}

.page-top-title {
  margin-bottom: 24px;
}
.page-top-title h1 {
  font-size: 24px;
  font-weight: normal;
  color: #333;
  margin: 0;
}

.asset-content-row {
  display: grid;
  grid-template-columns: 100%;
  gap: 16px;
}
.asset-table-wrap {
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  border: 1px solid #e8edf2;
}
/* 表格横向滚动容器，手机端可左右滑动 */
.table-scroll-wrap {
  width: 100%;
  overflow-x: auto;
}
.table-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.sub-menu-list {
  padding-top: 12px;
}
.sub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
}
.sub-menu-item:hover {
  background: #f0f9fe;
  color: #22b8e6;
}
.sub-menu-item i {
  font-size: 16px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .page-header {
    padding: 0 16px;
  }
  .sidebar-wrap {
    display: none;
  }
  .main-content {
    padding: 16px 12px;
  }
  .page-top-title h1 {
    font-size: 20px;
  }
  .asset-table-wrap {
    padding: 12px 8px;
  }
  .table-pagination {
    justify-content: center;
  }
}
</style>
